var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tooltip',{staticClass:"multiline-tooltip",attrs:{"label":_vm.label,"type":_vm.type,"active":_vm.active,"position":_vm.position,"append-to-body":true}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }